// IterationTypeComp.jsx
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Controller, useFieldArray } from "react-hook-form";
import { CaseProRulesItem } from "../CaseProRulesItem";

const emptyRule = {
  TYPE: "RULE",
};

const CaseProIterationTypeComp = ({
  control,
  register,
  schema,
  rule,
  path,
  depth,
}) => {
  const {
    fields: rules,
    append,
    remove,
  } = useFieldArray({
    control,
    name: `${path}.RULES`,
  });

  console.log("=====path", path, control);

  return (
    <Box
      mt={4}
      p={3}
      bg="yellow.50"
      borderRadius="md"
      border="1px solid"
      borderColor="yellow.200"
    >
      <Text fontWeight="medium" color="yellow.700" mb={2}>
        🔁 Iteration
      </Text>

      {/* Repeatable ID */}
      <FormControl mb={3}>
        <FormLabel>Repeatable ID</FormLabel>
        <Controller
          control={control}
          name={`${path}.REPEATABLE_ID`}
          render={({ field }) => (
            <Input {...field} bg="white" borderColor="gray.300" w="50%" />
          )}
        />
      </FormControl>

      {/* Nested Rules */}
      <Box pl={4} borderLeft="3px solid" borderColor="yellow.200">
        <Stack direction="row" mb={2} gap={2}>
          <Heading size="xs" color="yellow.700">
            Nested {path?.TYPE}
          </Heading>

          <Button
            size="xs"
            colorScheme="yellow"
            variant="outline"
            onClick={() => append(emptyRule)}
          >
            + Add Rule
          </Button>
        </Stack>

        <Stack spacing={3}>
          {rules.map((nestedRule, idx) => (
            <CaseProRulesItem
              key={nestedRule.id}
              control={control}
              register={register}
              schema={schema}
              rule={nestedRule}
              path={`${path}.RULES.${idx}`}
              remove={() => remove(idx)}
              depth={depth + 1}
              isStep
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default CaseProIterationTypeComp;
